<template>
	<div class="tos-main">
		<TosMess />
	</div>
</template>

<script>
import { eventBus } from '@/main';
export default {
	created() {
		eventBus.$emit('popoffall'); // Close all modal windows
	},
}
</script>

<style scoped>
.tos-main {
	height: 100%;
	overflow: hidden;
	background-color: #F6F6F6;
	padding: 10px;
	border: solid 0px #090;
}
</style>
